import { Component, Input, OnInit } from '@angular/core';
import { FilmModel } from '../../models/film';
import { FilmService } from "../../services/film.service";
import { ContributorModel } from '../../models/contributor';
import { ContributorService } from "../../services/contributor.service";
import { ContributorUniversity } from '../../models/contributoruniversity';
import { Observable } from 'rxjs/Observable';



@Component({
  moduleId: module.id,
  selector: 'site-aboutPageContributor',
  templateUrl: './aboutPageContributor.component.html',
  styleUrls: ['./aboutPageContributor.component.css']
})

export class AboutPageContributorComponent {
  @Input()
  contributorName: string;
  @Input()
  contributorTitle: string;
  @Input()
  contributorUniversity: string;
  @Input()
  contributorCredential1: string;
  @Input()
  contributorCredential2: string;
  @Input()
  contributorDescription: string;
  @Input()
  contributorFavoriteFilm: number;
  @Input()
  contributorFavoriteMovie: number;
  @Input()
  favoriteFilmYear: Date;
  @Input()
  favoriteMovieYear: Date;
  @Input()
  associationList: string;
  @Input()
  contributorImage: string;
}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/aboutPageContributor/aboutPageContributor.component.ts